








import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

const workflows = namespace('workflows')
const institutions = namespace('institutions')
const layout = namespace('layout')

type WorkflowCode = 'invoice_scrap_trigger' | 'tax_scrap_trigger' | 'enabling_hometax' | 'enabling_giro' | 'enabling_specific_bank'

@Component
export default class WorkflowHandler extends Vue {
  /**
   * trigger workflows set value
   */
  @Prop({default: false, type: Boolean}) isAvailableTriggerWorkflow: boolean
  @Prop({default: false, type: Boolean}) disabled: boolean
  @Prop({default: ''}) serviceName: string
  @Prop({default: () => ([])}) workflowCodes: WorkflowCode[]

  /**
   * workflow store
   */
  @workflows.Action('triggerWorkflow') triggerWorkflow
  @workflows.Action('getWorkflowStatus') getWorkflowStatus
  @workflows.State('loadingWorkflowStatus') loadingWorkflowStatus
  @workflows.Mutation('clear') clear
  @workflows.State('set') set

  /**
   * institutions store
   */
  @institutions.Action('getCertInstitutions') getCertInstitutions
  /**
   * layout store
   */
  @layout.Mutation('updateError') updateError: (errorItem: object) => void
  @layout.Mutation('updateToast') updateToast: (toastItem: object) => void

  get isActiveWorkflowCode() {
    for(const [, value] of Object.entries(this.set)) {
      const {code} = value as any || {}
      return this.workflowCodes.includes(code)
    }
    return null
  }

  @Watch('loadingWorkflowStatus', {immediate: true})
  __loadingWorkflowStatus(value) {
    if(value === 'completed' && this.isActiveWorkflowCode && !this.disabled) {
      this.$emit('completed')
      this.clear()
    }
  }

  delayTimeCondition(requestTime) {
    if(requestTime < 1) {
        return 5000
    }
    if(requestTime > 40) {
        return 10000
    }
    return 2000
  }

  afterNextCb(resp, requestTime) {
    if(requestTime > 180) {
      this.updateToast({
        id: 'monitor-workflow',
        message: `${this.serviceName} 정보를 불러오는데 시간이 지연되고 있습니다. 완료되면 카톡으로 알려드리겠습니다.`,
      })
    }
  }
  async onTriggerWorkflow() {
    if(this.loadingWorkflowStatus === 'loading') return
    await this.getCertInstitutions()
    if(this.isAvailableTriggerWorkflow) {
      this.clear()
      const {id} = await this.requestWorkflowId()
      if(id) {
        this.updateToast({
          id: 'trigger-workflow',
          message: `${this.serviceName}를 불러오는 중입니다.`
        })
        this.getWorkflowStatus({
          id,
          delayTimeCondition: this.delayTimeCondition,
          afterNextCb: this.afterNextCb,
        })
          .then(() => {
            this.updateToast({
              id: 'success-trigger-workflow',
              message: `${this.serviceName}를 모두 불러왔습니다.`,
            })
          })
          .catch(() => {
            this.updateError({
              id: 'trigger-workflow',
              message: `${this.serviceName} 정보를 불러오는데 실패하였습니다.`,
            })
          })
      }
    }
  }

  requestWorkflowId() {
    // TODO: refactor
    // triggerWorkflow 처리를 workflow handler 밖에서 하거나 workflowCodes만큼 실행하도록 개선 필요
    const [triggerWorkflowCode] = this.workflowCodes
    return this.triggerWorkflow(triggerWorkflowCode)
      .catch((error: any = {}) => {
        const {status} = error.response || {}
        if(status === 409) {
          this.updateToast({
            id: 'get-workflow-id',
            message: `이미 ${this.serviceName} 정보를 불러오고 있습니다. 잠시 후 다시 요청해주세요.`,
          })
          return error
        }

        this.updateError({
          id: 'trigger-workflow',
          message: `${this.serviceName} 정보를 불러오는데 실패하였습니다.`,
        })
        throw error
      })
  }
}
